import { render, staticRenderFns } from "./StandardizedAgreement.vue?vue&type=template&id=23581e4e&"
import script from "./StandardizedAgreement.vue?vue&type=script&lang=js&"
export * from "./StandardizedAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports